














































































































import Vue from "vue";
import { Wyrob } from "@megarax/client/src/resources/plm/Wyrob";

import { UrlEntry } from "@/components/sheet/SheetEntries";
import DefaultRevisionSheet from "@/components/DefaultRevisionSheet.vue";
import { createComponent } from "@vue/composition-api";

export default createComponent({
  components: {
    DefaultRevisionSheet,
  },
  props: {
    value: {
      type: Wyrob,
      required: true,
    },
  },
  setup(props, ctx) {
    return {};
  },
});
